import { NgModule } from '@angular/core';
import { SearchAllPipe } from './search-all.pipe';
import { GetCalificacionPipe } from './get-calificacion.pipe';
import { GetCalificacionTotalPipe } from './get-calificacion-total.pipe';
import { GetCalificarPipe } from './get-calificar.pipe';
import { GetCertificatePipe } from './get-certificate.pipe';

@NgModule({
  declarations: [
    SearchAllPipe,    
    GetCalificacionPipe,
    GetCalificacionTotalPipe,
    GetCalificarPipe,
    GetCertificatePipe
  ],
  exports: [
    SearchAllPipe,
    GetCalificacionPipe,
    GetCalificarPipe,
    GetCalificacionTotalPipe,
    GetCertificatePipe
  ]
})
export class PipesModule { }
